import Device from 'constants/deviceSizes';
import { customerSupportTopbarSize, defaultPaddingLeft } from 'constants/sizes';
import { superBig } from 'constants/fonts';

export default {
  container: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: `0px ${defaultPaddingLeft}px`,
    alignItems: 'center',
    height: `calc(130px - ${customerSupportTopbarSize}px)`,
    [Device.mobile]: {
      justifyContent: 'center',
      padding: '0px 10px 20px',
      flexWrap: 'wrap',
      height: 'auto'
    }
  },
  amountSection: {
    width: '50%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    [Device.mobile]: {
      width: '100%'
    }
  },
  buttonsSection: {
    display: 'flex'
  },
  paymentButtonSection: {
    [Device.mobile]: {
      width: '100%'
    }
  },
  superBigSize: {
    fontSize: superBig
  }
};
